import type { DataUnit, TimestampType } from '#lib/server/aggregation.types.js';

const millisInUnit: Record<TimestampType, number> = {
  epochMilliseconds: 1,
  epochSeconds: 1000,
  epochMinutes: 60_000,
};

export const unitMap: Record<string, string> = {
  '1': '',
};

export function getTimestampType(unit: DataUnit | TimestampType): TimestampType | undefined {
  if (typeof unit === 'string') return unit as TimestampType;
  if ('dateTime' in unit) return unit.dateTime;

  return undefined;
}

export function convertTimestamp(
  value: number,
  from: DataUnit | TimestampType,
  to: DataUnit | TimestampType,
): number {
  return (value * millisInUnit[getTimestampType(from)!]) / millisInUnit[getTimestampType(to)!];
}

export function convertToDate(value: number, unit: DataUnit | TimestampType): Date {
  const ts = convertTimestamp(value, getTimestampType(unit)!, 'epochMilliseconds');

  return new Date(ts);
}
